var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { alt: "", src: "images/xsm_jianzaoye.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [_vm._v("太保制造行业1-6类雇主险（限广东企业）")]),
                  _c("div", [
                    _vm._v("行业首选方案 | 中国太平洋产险承保 | 不限厂商品牌"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 保额更高，保费更便宜\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t② 误工费无免赔，100元/人/天，每次90天，累计180天\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t③ 医疗费0免赔，医保范围内100%赔付\n\t\t\t\t\t"
                    ),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t④ 扩展24小时个人意外\n\t\t\t\t\t"),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "crud",
                    attrs: {
                      "cell-style": _vm.onCellStyle,
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "赔付标准" } },
                [
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: {
                        data: _vm.dataBenefit,
                        option: _vm.optionBenefit,
                      },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (ref) {
                        var question = ref.question
                        if (question === void 0) question = ""
                        var answer = ref.answer
                        if (answer === void 0) answer = ""
                        return _c(
                          "li",
                          { key: question },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    width: "20px",
                                    "text-align": "center",
                                    "background-color": "MediumPurple",
                                    color: "white",
                                    padding: "4px",
                                    "border-radius": "4px",
                                    "margin-right": "8px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tQ\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [_vm._v(_vm._s(question))]
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "margin-top": "12px",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "20px",
                                      height: "28px",
                                      "background-color": "MediumSeaGreen",
                                      color: "white",
                                      padding: "4px",
                                      "border-radius": "4px",
                                      "margin-right": "8px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                                question ===
                                "中途是否可以加人？新增人员如何收费？"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t中途可以增加保障人员。保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "table",
                                          {
                                            staticStyle: { margin: "15px" },
                                            attrs: {
                                              border: "1",
                                              cellpadding: "0",
                                              ellspacing: "0",
                                              width: "100%",
                                            },
                                          },
                                          [
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("th", [
                                                  _vm._v("批增收费比例"),
                                                ]),
                                                _vm._l(12, function (item) {
                                                  return _c("th", [
                                                    _vm._v(
                                                      _vm._s(item) + "个月"
                                                    ),
                                                  ])
                                                }),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("td", [_vm._v("1-3类")]),
                                                _vm._l(
                                                  _vm.questionDataRate,
                                                  function (item) {
                                                    return _c("td", [
                                                      _vm._v(_vm._s(item)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("td", [_vm._v("4-5类")]),
                                                _vm._l(
                                                  _vm.questionDataRate,
                                                  function (item) {
                                                    return _c("td", [
                                                      _vm._v(_vm._s(item)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "tr",
                                              {
                                                staticStyle: {
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _c("td", [_vm._v("6类")]),
                                                _vm._l(
                                                  _vm.questionDataRate,
                                                  function (item) {
                                                    return _c("td", [
                                                      _vm._v(_vm._s(item)),
                                                    ])
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-wrap",
                                        },
                                      },
                                      [_vm._v(_vm._s(answer))]
                                    ),
                              ]
                            ),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "line-height": "26px",
                          "white-space": "pre-line",
                        },
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [_vm._v("投保须知及重要事项告知")]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "line-height": "32px",
                              "white-space": "pre-line",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t1、本保险适用以下保险条款： 2、本保险由中国太平洋财产保险股份有限公司承保，\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "仅限承保营业执照注册地址在广东的企业和组织"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t。\n\t\t\t\t\t\t\t3、在投保本保险前请您认真阅读《保险条款》，了解本保险的保险责任及责任免除，尤其是对其中免除保险人责任的条款(包括但不限于责任免除、投保人被保险人义务等)。在充分理解并接受上述内容的基础上，同意以此作为订立保险合同的依据。\n\t\t\t\t\t\t\t4、在投保本保险时您应如实填写各项投保信息以履行相应的如实告知义务，若故意或者因重大过失未履行如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同；\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费；\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担赔偿责任，并不退还保险费。\n\t\t\t\t\t\t\t5、本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t\t6、本保险根据投保单位的需求提供电子发票或纸质专票。 7、本保险由博维保险经纪有限公司面向\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v("广东省内销售并提供服务"),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。 8、\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。在保单生效后申请退保或批减在保人员的，可退保费为0。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(
                              "\n\t\t\t\t\t\t\t9、中途可以增加保障人员。\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t保单新增人员时，保费按照剩余的保险月数进行计费，不足一个月的按照一个月计算。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _c(
                              "table",
                              {
                                staticStyle: { margin: "15px" },
                                attrs: {
                                  border: "1",
                                  cellpadding: "0",
                                  ellspacing: "0",
                                  width: "100%",
                                },
                              },
                              [
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("th", [_vm._v("批增收费比例")]),
                                    _vm._l(12, function (item) {
                                      return _c("th", [
                                        _vm._v(_vm._s(item) + "个月"),
                                      ])
                                    }),
                                  ],
                                  2
                                ),
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("td", [_vm._v("1-3类")]),
                                    _vm._l(
                                      _vm.questionDataRate,
                                      function (item) {
                                        return _c("td", [_vm._v(_vm._s(item))])
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("td", [_vm._v("4-5类")]),
                                    _vm._l(
                                      _vm.questionDataRate,
                                      function (item) {
                                        return _c("td", [_vm._v(_vm._s(item))])
                                      }
                                    ),
                                  ],
                                  2
                                ),
                                _c(
                                  "tr",
                                  { staticStyle: { "text-align": "center" } },
                                  [
                                    _c("td", [_vm._v("6类")]),
                                    _vm._l(
                                      _vm.questionDataRate,
                                      function (item) {
                                        return _c("td", [_vm._v(_vm._s(item))])
                                      }
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v("\n\t\t\t\t\t\t\t10、\n\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "red-bold" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t本保单不承保职业：船舶制造人员\n\t\t\t\t\t\t\t\t、玻璃、陶瓷、搪瓷制造业人员、涉及爆破的相关工作人员，如作业内容含有保险人不承保的职业类别，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        ),
                        _c("el-divider"),
                        _c("h3", [_vm._v("特别约定")]),
                        _c("div", [
                          _c("h4", [_vm._v("1、保障期限：")]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t自所投保雇主责任保险生效日起，保险期限为一年。\n\t\t\t\t\t\t\t"
                          ),
                          _c("h4", [_vm._v("2、特别特约：")]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（1）被保险人必须在保险事故发生后48小时内报案，因延迟报案影响保险人查勘、定损的，保险人对无法核实的部分不承担任何赔偿责任。如果被保险人\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("超过72小时才报案"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t，则保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("免赔50%"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t。如果事故发生日期早于本保单生效日期，被保险人通过对事故发生日期造假的方式，从而在本保单提出索赔的行为则属于骗保，保险人有权提请相关机关追究被保险人及相关人员的法律责任。\n\t\t\t\t\t\t\t（2）被保险人从业人员的年龄限16-65周岁，本方案每人限投1份，超过部分无效。\n\t\t\t\t\t\t\t（3）鉴于被保险人的行业风险特性，本保单仅支持按年投保，不支持短期投保。\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "在保单生效后申请退保或批减在保人员的，可退保费为0。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（4）本保单仅承保制造相关行业。 （5）被保险人从业人员遭受伤害时，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t实际从事的工作危险程度高于投保人明确告知保险人的工作类型的，则保险人根据实际从事工作职业类别与保单约定职业类别的级差，按每一个级差扣减保额20%免赔（比如实际6类投保4类，需扣减40%免赔，以此类推）。如实际工作属于拒绝承保职业，保险人不承担任何赔偿责任。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（6）在工作时间和工作岗位，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t突发疾病死亡或者在48小时之内经抢救无效死亡（从业人员因疾病（包括职业病）、分娩、流产以及因上述原因接受医疗救治的不在该特约责任范围内），保险人承担赔偿责任，赔款=每人身故赔偿限额*20%。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（7）医疗费用适用独立的赔偿限额，不包含在死亡、伤残赔偿限额之内，按照实际指定就诊医院所在地的（地市级以上）劳动、卫生、社保行政部门公布的城镇职工医疗保险的范围及标准100%赔付。\n\t\t\t\t\t\t\t（8）误工费用适用独立的赔偿限额，不包含在身故、伤残及医疗费用赔偿限额之内。按100元/天的标准赔偿误工费，每人每次事故最高赔偿90天，累计不超过180天。误工费的计算包含住院期间、出院后的休息误工时间，其中出院后的休息误工时间取医嘱建休时间、实际误工时间及GAT1193-2014《人身损害误工期、护理期、营养期评定规范》规定标准三者中的最短时间，且一旦确定伤残程度后即刻停止误工费的计算。\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "被保险人从业人员仅接受门诊治疗的，按本保单约定无误工费赔付。"
                            ),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t（9）\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t被保险人从业人员从事高处作业必须佩戴安全带，从事特种作业必须取得有效特种作业操作证（包括但不限高处作业证）\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t，否则发生死亡或伤残事故，保险人对按保单约定的应承担的保险责任，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("免赔25%。"),
                          ]),
                          _vm._v("\n\t\t\t\t\t\t\t（10）\n\t\t\t\t\t\t\t"),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "本保单指定就诊医院为大陆境内二级及以上公立医院。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如因紧急抢救无法前往本保单指定就诊医院，须在保险事故发生后72小时内转入本保单指定就诊医院。对于前往非本保单指定就诊医院或未按本约定转入本保单指定就诊医院所产生的医疗费用，除非取得保险人认可，否则保险人有权拒绝赔偿。\n\t\t\t\t\t\t\t（11）兹经双方协商同意，鉴于投保人已支付相应保费，保险人扩展承保被保险人雇员在24小时内因意外事故到医院治疗被保险人依法应承担的经济赔偿责任，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t24小时意外事故医疗责任与雇主工伤医疗责任共用限额，最高不超过保单列明的工伤医疗责任限额。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t24小时意外事故医疗责任\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t不负责赔偿误工费、住院伙食费、生活护理费、转院就医食宿交通费、残疾辅助器具费用等其他费用。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（12）本保单伤残赔偿金：按伤残鉴定机构出具的伤残程度鉴定书，并对照国家发布的《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）（以下称《伤残鉴定标准》）确定伤残等级而支付相应赔偿金。相应的赔偿限额为该伤残等级所对应的下列“伤残等级赔偿限额比例表”的比例乘以每人死亡赔偿限额所得金额。本保单适用伤残赔付比例按：一级伤残 100％，二级伤残 80％，三级伤残 70％，四级伤残60％，五级伤残50％，六级伤残40％，七级伤残30％，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "八级伤残20％，九级伤残10％，十级伤残 5％。"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（13）本保单附加24小时个人意外事故条款，扩展承保被保险人的雇员在24小时内遭受意外事故造成的永久性伤残和死亡。其中，伤残评定标准参照《职工工伤与职业病致残程度鉴定标准》（GB/T16180-2014）评定，评定级别后赔偿金额计算标准同主险赔偿标准并以保单约定的伤残赔偿限额乘以该伤残等级对应于“伤残等级赔偿限额比例表”中的赔偿限额比例为限。\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t24小时个人意外事故死亡伤残责任与雇主工伤死亡伤残责任共用限额，每人最高不超过保单列明的雇主工伤死亡伤残责任限额的50%。对由于被保险人直接承担的因为被保险人的雇员从事的下列活动引起的责任，本保险不负责赔偿:打猎、登山、任何形式的竞赛、滑雪、酗酒、服用药物或狂欢。\n\t\t\t\t\t\t\t"
                            ),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t（14）本保单承保法律费用责任，\n\t\t\t\t\t\t\t"
                          ),
                          _c("span", { staticClass: "red-bold" }, [
                            _vm._v("累计赔偿限额为RMB10万元"),
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t\t\t，每次事故赔偿限额为RMB10万元。 （15）太平洋产险全国统一客户投诉电话：95500语音提示或按#号键-3-2-4。\n\t\t\t\t\t\t\t"
                          ),
                          _c("h4", [_vm._v("3、责任免除：")]),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t第一条 由于下列原因造成的任何损失、费用或赔偿责任，保险人不负责赔偿：\n\t\t\t\t\t\t\t\t（一）投保人、被保险人或其法人、代理人的违法行为、犯罪行为、故意行为或重大过失行为；\n\t\t\t\t\t\t\t\t（二）战争、敌对行动、军事行动、武装冲突、罢工、暴动、民众骚乱、恐怖活动；\n\t\t\t\t\t\t\t\t（三）核辐射、核爆炸、核污染，或其他放射性、有毒、易爆物质的污染或影响； （四）行政行为、司法行为；\n\t\t\t\t\t\t\t\t（五）接触、使用石棉（包括石棉制品、石棉纤维等含有石棉成份的物质）或硅（包括硅产品、硅石粉尘等以任何形态存在的硅）；\n\t\t\t\t\t\t\t\t（六）传染病、分娩、流产、保单已承保的职业病以外的其他疾病（包括免疫系统疾病及精神疾病），以及因前述原因而接受医疗、诊疗，但主条款第五条第（七）款不受此限。\n\t\t\t\t\t\t\t\t第二条 保险事故发生时，被保险人的雇员存在下列情形之一，并因此导致人身损害的，保险人不承担赔偿责任：\n\t\t\t\t\t\t\t\t（一）自杀、自残、打架、斗殴、受酒精或毒品的影响； （二）故意行为、违法行为、犯罪行为；\n\t\t\t\t\t\t\t\t（三）进行下列高风险运动、活动：\n\t\t\t\t\t\t\t\t1．从事潜水、登山、滑水、滑雪、滑冰、滑板、滑翔、跳伞、攀岩、蹦极或其他类似的极限运动；\n\t\t\t\t\t\t\t\t2．进行探险活动； 3．进行摔跤、柔道、空手道、跆拳道、拳击或其他类似的搏击运动；\n\t\t\t\t\t\t\t\t4．进行需要经过特别训练的特技表演； 5．参与任何职业、半职业或专业的体育运动；\n\t\t\t\t\t\t\t\t6．进行赛马、各种车辆表演、车辆竞赛或练习、驾驶卡丁车等高风险运动。\n\t\t\t\t\t\t\t\t（四）未遵医嘱，私自过量或不足量服用、涂用、注射药物或进行任何非治疗工伤所必须的手术；\n\t\t\t\t\t\t\t\t（五）无驾驶证，驾驶证失效或者被依法扣留、暂扣、吊销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车；\n\t\t\t\t\t\t\t\t（六）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的。\n\t\t\t\t\t\t\t\t第三条 下列损失、费用和责任，保险人不承担赔偿责任： （一）被保险人对本合同生效前已发生事故的赔偿责任；\n\t\t\t\t\t\t\t\t（二）除本合同列明负责赔偿的项目外，其他超出被保险人职员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；\n\t\t\t\t\t\t\t\t（三）精神损害赔偿及任何性质的罚款、罚金、惩罚性赔偿；\n\t\t\t\t\t\t\t\t（四）被保险人因合同或协议（含劳动合同、用工协议等）的约定而应承担的赔偿责任，但无该合同或协议的存在被保险人依法仍应承担的赔偿责任不受此限；\n\t\t\t\t\t\t\t\t（五）被保险人的任何间接损失； （六）被保险人应自行承担的免赔额。 第四条\n\t\t\t\t\t\t\t\t其他不属于本保险责任范围内的损失、费用和责任，保险人不负责赔偿。\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }